const es = {
  "vps.databases": "Bases de Datos",
  "vps.databases.vps": "Servidor",
  "vps.databases.state": "Estado",
  "vps.databases.customer": "Cliente",
  "vps.databases.name": "Base de Datos",
  "vps.databases.enable": "Habilitada",
  "vps.databases.disable": "Deshabilitada",
  "vps.databases.customer.filter": "Filtro Cliente",
  "vps.databases.vps.filter": "Filtro Servidor",
  "vps.databases.state.filter": "Filtro Estado",
};
export default es;
